import * as Yup from 'yup';
import { removeSpecialChars } from '../../../../../services/mask';
import { isValidCPF } from '../../../../../utils/isValidCpf';

const schema = Yup.object().shape({
  privateDrivers: Yup.array().of(
    Yup.object()
      .shape({
        username: Yup.string()
          .matches(
            /^[a-zA-Z0-9áéíóúâêîôûàèìòùãõçÁÉÍÓÚÂÊÎÔÛÀÈÌÒÙÃÕÇ\s-]+$/,
            'O nome deve conter apenas letras e números',
          )
          .max(100, 'O nome pode ter até 100 caracteres')
          .required('Nome não pode estar vazio'),
        cpf: Yup.string()
          .test(
            'is-valid-length',
            'O CPF do motorista deve ter 11 caracteres numéricos',
            function (value) {
              const valueClean = removeSpecialChars(value as string);
              return valueClean.length == 11;
            },
          )
          .test('valid-cpf', 'O CPF não é valido', function (value) {
            return isValidCPF(removeSpecialChars(value as string));
          })
          .required('O CPF do motorista não pode estar vazio'),
        phoneNumber: Yup.string()
          .test(
            'is-valid-length',
            'O Número do celular do motorista precisa ter 11 caracteres',
            function (value) {
              const valueClean = removeSpecialChars(value as string);
              return valueClean.length == 11;
            },
          )
          .required('O número do celular do motorista não pode estar vazio'),
      })
      .required(),
  ),
});

export type formSchemaType = Yup.InferType<typeof schema>;

export default schema;
